import { render } from "./NConfirm.vue?vue&type=template&id=627f52d4&ts=true"
import script from "./NConfirm.vue?vue&type=script&lang=ts"
export * from "./NConfirm.vue?vue&type=script&lang=ts"

import "./NConfirm.vue?vue&type=style&index=0&id=627f52d4&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__